/**
 *    themeColor：高亮颜色，默认为蓝色，可传入指定颜色
 *    data 数据
 *    keyword 高亮的关键字
 *    ...word 数据中需要遍历的属性名，更改属性值中的关键字，可以输入数组，字符串
 **/
let keywordHeightLightPlugin = {
  install (Vue) {
    Vue.prototype.keywordHeightLight = (themeColor, data, keyword, insertArray) => {
      let color
      if (themeColor === 'defaultTheme') {
        color = '#2f78ec'
      }
      if (insertArray.length > 0) {
        for (let n in data) {
          for (let j in data[n]) {
            for (let i in insertArray) {
              if (j === insertArray[i]) {
                data[n][j] = data[n][j].replace(new RegExp(keyword, 'ig'), (txt) => `<a style="color:${color};">${txt}</a>`)
              }
            }
          }
        }
      }
    }
    Vue.prototype.clearKeywordHeightLight = (themeColor, data, insertArray) => {
      let color
      if (themeColor === 'defaultTheme') {
        color = '#2f78ec'
      }
      if (insertArray.length > 0) {
        for (let j in data) {
          for (let i in insertArray) {
            if (j === insertArray[i]) {
              data[j] = data[j].replace(`<a style="color:${color};">`, '')
              data[j] = data[j].replace(`</a>`, '')
            }
          }
        }
      }
    }
  }
}
export default keywordHeightLightPlugin



// WEBPACK FOOTER //
// ./src/plugins/KeywordHeightLight.js